import React, { Suspense } from 'react'

import Helmet from 'react-helmet'

import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import messages from './messages'

export const BUDGET_CATEGORY_CREATE_PAGE = '/settings/budget-categories/create'
export const BUDGETS_CREATE_PAGE = '/settings/budgets/create'

const BudgetCategoryCreateChunk = React.lazy(() =>
  import('../containers/BudgetCategoryUpsertView').then(
    ({ BudgetCategoryUpsertView }) => ({
      default: BudgetCategoryUpsertView,
    })
  )
)

export const BudgetCategoryCreatePage = () => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  return (
    <Suspense fallback={null}>
      <Helmet>
        <title>
          Procurify |{' '}
          {intl.formatMessage(
            FT_5817_ENABLE_BUDGETS_REDESIGN
              ? messages.createBudgetTitle
              : messages.createBudgetCategoryTitle
          )}
        </title>
      </Helmet>
      <BudgetCategoryCreateChunk />
    </Suspense>
  )
}
